import styled from 'styled-components';

const ResultsContainer = styled.div`
  margin-top: 30px;
`;

ResultsContainer.displayName = 'ResultsContainer';

export default ResultsContainer;
